var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPositive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.38454 4.98682L3.20724 4.98682L3.20724 10.4782L1.38454 10.4782C1.28255 10.4782 1.18474 10.4324 1.11263 10.3507C1.04051 10.2691 1 10.1584 1 10.0431L1 5.42195C1 5.30655 1.04051 5.19587 1.11263 5.11426C1.18474 5.03267 1.28255 4.98682 1.38454 4.98682Z",
    stroke: "#A9A9AE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.20728 4.98645L5.16071 1.45316C5.23642 1.31352 5.3428 1.19843 5.46949 1.11912C5.59618 1.03981 5.73887 0.998997 5.88364 1.00063C5.99767 0.99597 6.11136 1.01722 6.21799 1.06314C6.32464 1.10905 6.42206 1.17868 6.50451 1.26793C6.58696 1.35717 6.65277 1.46421 6.69803 1.58273C6.7433 1.70124 6.76712 1.82881 6.76807 1.95792L6.76807 4.49039L10.1443 4.49039C10.269 4.49497 10.3915 4.52937 10.5037 4.59136C10.6159 4.65333 10.7152 4.74146 10.7951 4.84997C10.875 4.95848 10.9337 5.08489 10.9673 5.22091C11.001 5.35693 11.0088 5.49946 10.9903 5.63914L10.375 10.1297C10.3488 10.3697 10.2459 10.5906 10.0859 10.7509C9.92594 10.9111 9.71966 10.9997 9.50594 11L4.46086 11C4.2207 11.001 3.98365 10.9385 3.7687 10.8172L3.21497 10.5039",
    stroke: "#A9A9AE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.20728 4.98657L3.20728 10.478",
    stroke: "#A9A9AE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPositive);
export default __webpack_public_path__ + "static/media/positive.4a05bb53efd830678694da52bccc17eb.svg";
export { ForwardRef as ReactComponent };